import React from 'react';
import SideBar from "./layouts/sidebar";
import AOS from "aos";
import Typed from 'react-typed';
import About from "./layouts/about";
import Contact from "./layouts/contact";
import Facts from "./layouts/facts";
import Footer from "./layouts/footer";
import Resume from "./layouts/resume";
import {getStateFromSelector} from "../redux/store";
import {CURRENT_SESSION_STATE_REDUCER} from "../redux/reducers";
import {useDispatch} from "react-redux";
import {toggleMobileNavView} from "../redux/action";
import Skills from "./layouts/skills";
import Services from "./layouts/services";

AOS.init();
const Home = () => {
    const dispatch = useDispatch()
    const {mobileNav,pageTitle} = getStateFromSelector(CURRENT_SESSION_STATE_REDUCER);
    const [toggleIcon,SetToggleIcon] = React.useState("bi-list")
    const sideBarToggleFunction =()=>{
        if (mobileNav){
            document.body.classList.add('mobile-nav-active');
            SetToggleIcon("bi-x");
        }
        else{
            document.body.classList.remove('mobile-nav-active');
            SetToggleIcon("bi-list");
        }
        dispatch(toggleMobileNavView(!mobileNav))
    }
    return (
        <div>

        <i className={`bi ${toggleIcon} mobile-nav-toggle d-xl-none`} onClick={()=>sideBarToggleFunction()}/>

        <header id="header">
            <SideBar />
        </header>

        <section id="hero" className="d-flex flex-column justify-content-center align-items-center">
            <div className="hero-container1" id="area-render" data-aos="fade-in">
            </div>
            <div className="hero-container">
                <h1>Hey there, <br/>Er. {pageTitle}</h1>
                <p>I'm  <Typed
                    strings={[
                        'Full-Stack Developer',
                        'UI/UX Developer',
                        'Application Developer',
                        "Freelancer"
                    ]}
                    typeSpeed={40}
                    backSpeed={50}
                    loop >
                    <input type="text" disabled={true} style={{ backgroundColor:'transparent',border:0, color:'white' }} />
                </Typed>
                </p>
            </div>
        </section>

        <main id="main">

            <section id="about" className="about">
                    <div className="container">

                        <div className="section-title">
                            <h2>Who I am?</h2>
                            <p>Born in 1997, New Delhi, India.
                                <br />In the 2nd year(2016) of my graduation, I decided to learn programming languages after that, I
                                    grabbed an internship and working as a software developer.</p>
                        </div>

                        <div className="row">
                            <div className="col-lg-4" data-aos="fade-right">
                                <img
                                    src={require('../asserts/images/me.jpeg')}
                                    className="img-fluid" alt="" style={{ borderRadius:'10%' }}/>
                            </div>
                            <div className="col-lg-8 pt-4 pt-lg-0 content" id="aboutSection" data-aos="fade-left">
                            <About />

                            </div>
                        </div>

                    </div>
                </section>

            <section id="resume" className="resume section-bg">
                <Resume />
            </section>

            <section id="skills" className="skills ">
                 <Skills />
            </section>


            <section id="projects" className="services section-bg">
                    <Services />
                </section>
            <section id="facts" className="facts ">
                    <Facts />
                </section>

            <section id="contact" className="contact section-bg">
                    <div className="container">

                        <div className="section-title">
                            <h2>Contact</h2>
                            <p>Contact me for any queries</p>
                        </div>

                        <div className="row" data-aos="fade-in">

                            <div className="col-lg-5 d-flex align-items-stretch">
                                <div className="info">
                                    <div className="address">
                                        <i className="bi bi-geo-alt" />
                                        <h4>Location:</h4>
                                        <p>Deepak Vihar extn, Vikas Nagar, New Delhi </p>
                                    </div>

                                    <div className="email">
                                        <i className="bi bi-envelope" />
                                        <h4>Email:</h4>
                                        <p>structlooper@gmail.com</p>
                                    </div>

                                    <div className="phone">
                                        <i className="bi bi-phone" />
                                        <h4>Call:</h4>
                                        <p>(+91) 767-817-8911</p>
                                    </div>
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.7961864039576!2d77.04596891508267!3d28.635869982416477!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d0578a6336755%3A0xf0ba94a80c5305f9!2sstructlooper!5e0!3m2!1sen!2sin!4v1622785858372!5m2!1sen!2sin"
                                        style={{ border:0, width: '100%', height: '290px' }} allowFullScreen=""
                                        loading="lazy">

                                    </iframe>

                                </div>

                            </div>

                            <div className="col-lg-7 mt-5 mt-lg-0 d-flex align-items-stretch" id="contactForm">
                                <Contact />
                            </div>

                        </div>

                    </div>
                </section>

        </main>

        <footer id="footer">
                <Footer />
            </footer>

        <a href="#" className="back-to-top d-flex align-items-center justify-content-center"><i
                className="bi bi-arrow-up-short" /></a>



        </div>
    );
};

export default Home;